export default "__VITE_ASSET__Clx2VQA7__"